import styled from 'styled-components';

export const StoriesPageContainer = styled.div`
    padding: 2rem 1rem;
    position: relative;
    overflow: hidden;
    z-index: 1;
    min-height: 100vh;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.05;
        z-index: -1;
    }
`;

export const StoriesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    padding: 2rem 0;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 1.5rem;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        padding: 1rem;
    }
`;

export const StoryCard = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
        border-color: rgba(255, 255, 255, 0.3);
    }
`;

export const StoryImage = styled.div`
    width: 100%;
    height: 200px;
    overflow: hidden;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
    }

    ${StoryCard}:hover & img {
        transform: scale(1.05);
    }
`;

export const StoryContent = styled.div`
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    color: white;
`;

export const StoryTitle = styled.h3`
    font-size: 1.4rem;
    margin-bottom: 1rem;
    font-weight: 700;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.3;
`;

export const StoryExcerpt = styled.p`
    font-size: 0.95rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    opacity: 0.9;
    color: rgba(255, 255, 255, 0.9);
    flex-grow: 1;
`;

export const ViewButton = styled.button`
    display: inline-block;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    color: white;
    text-decoration: none;
    border-radius: 25px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(107, 91, 255, 0.4);
    font-size: 0.9rem;
    width: 100%;
    margin-top: auto;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(107, 91, 255, 0.6);
    }
`;

// Modal Styles - Renderizado via Portal, siempre encima de todo
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    padding: 1rem;
    opacity: ${props => props.isOpen ? 1 : 0};
    visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
    transition: all 0.3s ease;
`;

export const ModalContainer = styled.div`
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 25px;
    max-width: 800px;
    width: 100%;
    max-height: 85vh;
    overflow-y: auto;
    position: relative;
    transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
        max-height: 80vh;
        margin: 0 0.5rem;
    }
`;

export const ModalCloseButton = styled.button`
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 2rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10002;

    @media (max-width: 768px) {
        top: 15px;
        right: 15px;
        width: 44px;
        height: 44px;
        font-size: 1.8rem;
    }

    &:hover {
        background: rgba(255, 107, 139, 0.4);
        border-color: rgba(255, 107, 139, 0.6);
        transform: rotate(90deg) scale(1.1);
    }

    &:active {
        transform: rotate(90deg) scale(0.95);
    }

    &:focus {
        outline: 2px solid rgba(255, 107, 139, 0.8);
        outline-offset: 2px;
    }
`;

export const ModalImage = styled.div`
    width: 100%;
    height: 300px;
    overflow: hidden;
    border-radius: 25px 25px 0 0;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const ModalContent = styled.div`
    padding: 2.5rem;
    color: white;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`;

export const ModalTitle = styled.h2`
    font-size: 2rem;
    margin-bottom: 1.5rem;
    font-weight: 700;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
        font-size: 1.6rem;
    }
`;

export const ModalFullStory = styled.div`
    font-size: 1.1rem;
    line-height: 1.8;
    opacity: 0.95;
    color: rgba(255, 255, 255, 0.9);

    p {
        margin-bottom: 1.5rem;
    }

    @media (max-width: 768px) {
        font-size: 1rem;
        line-height: 1.6;
    }
`;